<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit Game Logo</span>

  <ng-container dialog-content>
    <div class="margin-top-med">
      <div class="text-underline">Game Logo:</div>

        <img [src]="assetManagementService.gameLogoUrl" style="max-width: 300px;" alt="Uploaded Image" class="padding-med" [style.background-color]="assetManagementService.toolbarColor"/>

        <input type="file"
               accept=".svg"
               class="file-input display-none"
               (change)="onGameLogoFileSelected($event)" #gameLogoUpload>

        <div class="margin-top-med">
          <button color="primary" mat-raised-button
                  (click)="gameLogoUpload.click()">
            <mat-icon>attach_file</mat-icon>
            Search images
          </button>
        </div>
    </div>

    @if (assetManagementService.gameLogoUrl) {
      <mat-toolbar class="sample-header margin-top-large" [style.background-color]="assetManagementService.toolbarColor">
        <button mat-icon-button
                class="margin-right-med"
                aria-label="icon for opening the side menu on smaller screens">
          <mat-icon [style.color]="assetManagementService.iconColor">menu</mat-icon>
        </button>
        <img [src]="assetManagementService.gameLogoUrl" style="max-width: 300px; height: 50px;" width="auto;" height="50px;" alt="Uploaded Image"/>
      </mat-toolbar>

      <mat-form-field appearance="outline" class="full-width margin-top-large">
        <mat-label>Game Theme Type</mat-label>
        <mat-select placeholder="choose how often the draw will happen"
                    (valueChange)="onThemeTypeChange($event)">
          <mat-option [value]="gameThemeType.Light">Light</mat-option>
          <mat-option [value]="gameThemeType.Dark">Dark</mat-option>
        </mat-select>
      </mat-form-field>
    }
  </ng-container>

  <ng-container actions>
    <button mat-button data-testid="save-image" (click)="saveGameLogo()">Submit</button>
  </ng-container>
</app-dialog-base>
